import { render, staticRenderFns } from "./SetTestDetail.vue?vue&type=template&id=4dd6a1da&scoped=true&"
import script from "./SetTestDetail.vue?vue&type=script&lang=js&"
export * from "./SetTestDetail.vue?vue&type=script&lang=js&"
import style0 from "./SetTestDetail.vue?vue&type=style&index=0&id=4dd6a1da&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dd6a1da",
  null
  
)

export default component.exports